<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		props:{
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			tableDataI:{
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				delCells:[],
				option:[{value: '1',lable: '发票',}, {value: '2',lable: '财政票据',}, {value: '3',lable: '境外签收单据',}, {value: '4',lable: '完税凭证',}, {value: '5',lable: '其它凭证',}]
			};
		},
		created() {
		},
		methods: {
			inputblur(e){
			this.$emit("inputblur",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			selectchange(e){
				this.option.map(item=>{
					if(item.value==e.whsy_1_x_4.cellVal){
						e.whsy_1_x_4a.cellVal = item.lable
					}
				})
			},
			fordelete(index){
				if(this.tableDataI.length<3){
					return false
				}
				if(this.$notemptyandnull(this.tableDataI[index]['whsy_1_x_1'].id)){
					this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])) )
				}
			this.tableDataI.splice(index,1)	
			this.$emit('delCellsCode',this.delCells)
			},
			foraddhang() {
				let endobj=this.tableDataI[this.tableDataI.length-1]
				this.tableDataI.pop()
				this.tableDataI.push({
					whsy_1_x_1: {
						cellCode: "whsy_1_"+(parseFloat(this.tableDataI.length)+1)+"_1",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					whsy_1_x_2: {
						cellCode: "whsy_1_"+(parseFloat(this.tableDataI.length)+1)+"_2",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					whsy_1_x_3: {
						cellCode: "whsy_1_"+(parseFloat(this.tableDataI.length)+1)+"_3",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					whsy_1_x_4: {
						cellCode: "whsy_1_"+(parseFloat(this.tableDataI.length)+1)+"_4",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					whsy_1_x_4a: {
						cellCode: "whsy_1_"+(parseFloat(this.tableDataI.length)+1)+"_4a",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					whsy_1_x_5: {
						cellCode: "whsy_1_"+(parseFloat(this.tableDataI.length)+1)+"_5",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					},
					whsy_1_x_6: {
						cellCode: "whsy_1_"+(parseFloat(this.tableDataI.length)+1)+"_6",
						cellType: "0",
						cellVal: "",
						updateDesc:"",
						map:{}
					}
				})
				this.tableDataI.push(endobj)
			}
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
